import React from 'react'
import { HighlightedElement } from './utils'

export default function QuipGuide({ className, style }) {
  return (
    <section className={className} style={style}>
      <p>
        While you can import your Quip content into Slite, unfortunately Quip
        doesn't support mass export so you'll have to import files one by one.
        Here's how:
      </p>
      <br />
      <ol style={{ paddingLeft: 15 }}>
        <li>
          In Quip, select the document icon at the top left of the screen and
          click "Export"
        </li>
        <li>
          Export as <HighlightedElement>markdown</HighlightedElement> or{' '}
          <HighlightedElement>html</HighlightedElement>
        </li>
        <li>
          In Slite, import the html files via the Import content via the top
          left dropdown{' '}
          <span role="img" aria-label="boom">
            💥
          </span>
        </li>
      </ol>
    </section>
  )
}
